import { Directive } from '@angular/core';

@Directive({
  selector: '[currenySymbol]'
})
export class CurrenySymbol {

  constructor() { }

}
